$(document).ready(function () {
	$(document).on('click', '[data-qty]', function () {
		let $self = $(this),
			$container = $self.closest('[data-cart="qty"]'),
			$counter = $container.find('[data-qty-cnt]'),
			value = parseInt($counter.text()),
			max = parseInt($container.data('max')),
			step = parseFloat($container.data('step')) || 1,
			btn = $self.attr('data-qty'),
			unRemove = $container.data('unremove') || false;

		if (btn === 'trash') return true;

		let result = inputQtyResult(value, btn, step, 1);

		if (!isNaN(max)) {
			if (result <= max) {
				if (result > step) {
					$counter.text(result);
				} else {
					$counter.text(step);
				}
			} else {
				$counter.text(max);

				/*let text = $container.data('max-text');
				if (text) {
					text = text.replace(':cnt', max);
					alert(text)
				}*/
			}
		} else {
			$counter.text(result);
		}

		if (max && max === result) {
			$counter.addClass('is-max');
			$container.find('[data-qty="plus"]').attr('disabled', 'true');
		} else {
			$counter.removeClass('is-max');
			$container.find('[data-qty="plus"]').removeAttr('disabled');
		}

		if (result === step || result === 0 || result < step) {
			if (!unRemove) {
				$container.find('button').first().attr('data-qty', 'trash');
			}
		} else {
			$container.find('button').first().attr('data-qty', 'minus');
		}

		$container.trigger('change-counter');

		return false;
	});

	function inputQtyResult(val, sign = '', step = 1, fixed = 0) {
		let result = step;

		if (sign && (sign === 'plus' || sign === 'minus')) {
			if (sign === 'plus') result = val + step;
			if (sign === 'minus') result = val - step;
			if (fixed > 0) result = result.toFixed(fixed);
		}

		return parseFloat(result);
	}

	/*$(document).on('blur', 'input[name="total"]', function () {
		let $self = $(this),
			max = parseFloat($self.attr('max')),
			value = parseFloat($self.val());

		if (value > max) {
			$('[data-qty="plus"]').trigger('click');
		}

		if (value === 0 || value < 0) {
			$self.val(1)
		}

		return false;
	});*/
});
